import React from 'react';

import { Container, Icon, Label } from './styles';

type Props = {
  children: string;
  className?: string;
};

const ErrorTag = ({ children, className }: Props) => (
  <Container className={className}>
    <Icon src="/images/exceeded-icon.svg" />
    <Label>{children}</Label>
  </Container>
);

export default ErrorTag;
